import React from "react"
import styled from "styled-components"
import Overview from "./Overview"
import ContentList from "./ContentList"
import ClosingText from "./ClosingText"
import { FooterBlock } from "./FooterBlock"

const StyledContentLayout = styled.div`
  margin: 0 auto;
  padding: 50px 5%;
  max-width: 1000px;
  font-size: 0.9em;
  line-height: 1.5;
  color: ${props => props.theme.colors.text};
`

export default function ContentBlock() {
  return (
    <StyledContentLayout>
      <Overview />
      <ContentList />
      <ClosingText />
      {/* <FooterBlock /> */}
    </StyledContentLayout>
  )
}
